import { Link } from "react-router-dom";

export default function BespokeServicesCTA() {
  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="relative overflow-hidden rounded-xl bg-graphite-850 border border-emerald-500/20 ring-1 ring-emerald-500/10">
            {/* Emerald accent left border */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-emerald-500" />

            {/* Subtle emerald glow */}
            <div className="absolute -right-20 -top-20 w-64 h-64 bg-emerald-500/5 rounded-full blur-3xl pointer-events-none" />

            <div className="relative px-6 py-10 md:px-10 md:py-12 lg:px-14 lg:py-14 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-emerald-500/10">
                    <i className="ri-code-box-line text-emerald-accent" />
                  </div>
                  <span className="text-xs font-semibold uppercase tracking-widest text-emerald-accent">
                    Custom Solutions
                  </span>
                </div>

                <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
                  Need something built for you?
                </h2>

                <p className="text-base text-silver-300 leading-relaxed max-w-2xl">
                  If your workflows are unique or your industry has specific requirements that our
                  11 off-the-shelf modules do not fully cover, StackMap designs and builds custom software
                  solutions from the ground up. We also provide strategic technology consultation for
                  organisations planning their operational infrastructure.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 shrink-0">
                <Link
                  to="/contact#form"
                  className="btn-primary inline-flex items-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  Talk to Us
                </Link>
                <Link
                  to="/bespoke"
                  className="btn-outline whitespace-nowrap"
                >
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}